import { formatDayMonthYear } from '../../../../utils/date-only';
import { SHIPMENT_STATUS_LABELS } from '../../shipment/models/shipment.view-model';
import { OrderPhoto } from '../../orders-new/models/order.dto';
import { ShipmentListItemDto } from './shipment-list-item.dto';

export interface ShipmentRowVm {
  id: number;
  shipmentNumber: string;
  transport: string;
  plannedDateLabel: string | null;
  statusLabel: string;
  itemCount: number;
  /**
   * "ZK-01/2026, ZK-03/2026" — empty for a shipment with nothing on it yet.
   */
  clientOrdersLabel: string;
  /** The wysyłka's faces (0082); the row shows the first, a click flips to the next (0085), a blank slot when empty. */
  photos: OrderPhoto[];
}

export namespace ShipmentRowVm {
  export function mapModelToViewModel(shipment: ShipmentListItemDto): ShipmentRowVm {
    return {
      id: shipment.id,
      shipmentNumber: shipment.shipmentNumber,
      transport: shipment.transport,
      plannedDateLabel: shipment.plannedDate ? formatDayMonthYear(shipment.plannedDate) : null,
      statusLabel: SHIPMENT_STATUS_LABELS[shipment.status],
      itemCount: shipment.itemCount,
      clientOrdersLabel: shipment.clientOrderNumbers.join(', '),
      photos: shipment.photos
    };
  }
}
